module.exports = __webpack_public_path__ + "static/media/deleteIcon.6a28050b.svg";